import { namespace } from 'wsm-tagging-utils';

const runDecorator = (win) => {
	namespace(win, 'DDC.tracking.adobe_launch.decorators');

	const {
		DDC: { tracking }
	} = win;

	/**
	 * Performs events decoration/transformation to meet program requirements.
	 * @constructor
	 * @see tracking.framework.runtime.EventHandlerDecorator
	 */
	tracking.adobe_launch.decorators.Decorator = class Decorator extends (
		tracking.framework.runtime.EventHandlerDecorator
	) {
		constructor(thisWin, page, delegate) {
			super(thisWin, page, delegate);

			/**
			 * Map of widget section name to selector that should define that section.
			 */
			this.formCategorySelectors = new Map([['SERVICE_APPT', 'other']]);
		}

		handleFormChange(eventData = {}) {
			const { element, label } = eventData;

			// route SRP and VLP sort by changes as link clicks
			if (
				element instanceof Element &&
				element.matches(
					'.vlp-refine-sort-by select, .facet-filters select'
				)
			) {
				// clone to prevent change to original event object
				const shallowClone = $.extend({}, eventData);
				shallowClone.text = label;
				shallowClone.linkType = 'search.link';
				shallowClone.uniqueEvent = 'vlp-srp-sort-by-dropdown';
				this.log.debug(
					'rerouting VLP sort by change to link click event'
				);
				this.delegate.handleLinkClick(shallowClone);
				return;
			}

			this.delegate.handleFormChange(eventData);
		}

		handleFormInitiation(eventData = {}) {
			const { trackingId = '' } = eventData;

			/**
			 * Consuming form initiation event on MYCARS_REGISTER form to maintain
			 * consistency with other MyCars login form behavior.
			 */
			if (trackingId.indexOf('MYCARS_REGISTER') > -1) {
				this.log.debug(
					'consuming MyCars register form initiation event'
				);
				return;
			}

			this.delegate.handleFormInitiation(eventData);
		}

		handleFormSubmission(eventData = {}) {
			const { trackingId = '' } = eventData;

			/**
			 * Route MyCars register form submission event to click event to
			 * maintain consistency with other MyCars login form behavior.
			 */
			if (trackingId.indexOf('MYCARS_REGISTER') > -1) {
				this.log.debug(
					'rerouting MyCars register form submission event to link click event'
				);
				this.delegate.handleLinkClick(eventData);
				return;
			}

			this.delegate.handleFormSubmission(eventData);
		}

		// route MyCars login events as click events
		handleMycarsLogin(eventData = {}) {
			this.log.debug('rerouting MyCars login event to link click event');
			this.delegate.handleLinkClick(eventData);
		}

		handleFormConfirmation(eventDataIn = {}) {
			const eventData = eventDataIn;
			eventData.formCategory = this.formCategorySelectors.get(
				eventData.trackingId
			);
			this.delegate.handleFormConfirmation(eventData);
		}
	};

	tracking.adobe_launch.decorators.Decorator.prototype.logCategory =
		'Decorator';
};

export default runDecorator;
